import { enqueue, flush } from './behaviorTracker';

export type { BehaviorEventInput, BehaviorEventType } from './behaviorTracker';

/**
 * 画面側から呼ぶ行動分析の公開 API。
 *
 * - behavior.step('onboarding', 'url-input')  … ファネルのステップ到達
 * - behavior.action('checkout_started', {plan}) … 明示的な操作
 * - behavior.track(...)                         … 任意イベント（通常は上 2 つで足りる）
 * - behavior.flush()                            … 画面遷移（外部リダイレクト）前に送り切る
 */
export const behavior = {
  step: (flow: string, step: string, props?: Record<string, unknown>): void =>
    enqueue({
      event_type: 'step',
      event_name: `${flow}:${step}`,
      props: { flow, step, ...props },
    }),
  action: (name: string, props?: Record<string, unknown>): void =>
    enqueue({ event_type: 'action', event_name: name, props }),
  track: enqueue,
  flush,
};

export default behavior;
